import { render, staticRenderFns } from "./Main.ModalBox.vue?vue&type=template&id=378ea79d&scoped=true&"
import script from "./Main.ModalBox.vue?vue&type=script&lang=js&"
export * from "./Main.ModalBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ea79d",
  null
  
)

export default component.exports